"use client";
import React from "react";
import {ReactComponent as StarIcon} from "../../src/assets/icons/star.svg";
import {ReactComponent as StarBoldIcon} from "../../src/assets/icons/starFill.svg";
/**
 * @param {{ rating: number, total?: number, className?: string }} props
 */
const Star = ({rating, total = 5, className}) => {
    return (
        <div className={`flex items-center gap-1 ${className || ""}`}>
            {Array.from({length: total}, (_, i) => {
                const starNumber = i + 1;
                return starNumber <= rating ? (
                    <StarBoldIcon key={i} className="w-4 h-4"/>
                ) : (
                    <StarIcon key={i} className="w-4 h-4"/>
                );
            })}
        </div>
    );
};

export default Star;
